import { selectApiData, selectApiNoContent } from 'util/selector/apiSelector';
import { selectResponseData } from 'util/selector/axiosSelector';

import { ApiMessage } from 'api/const';
import { WithData } from 'api/interfaces';
import { AxiosInstance } from 'axios';
import qs from 'qs';
import { Exception } from 'exception/Exception';

import {
  mapUserDtoToModel as mapUserDtoToModel,
  mapUserModelToSendDto,
  PaginatedUserListDto,
  PaginatedUserListModel,
  PaginatedUserListSendDto,
  UserDto,
  UserModel,
} from './dto/User.dto';

export class UserApi {
  constructor(private adminClient: AxiosInstance) {}

  listPaginated(
    projectId: number,
    query?: PaginatedUserListSendDto,
  ): Promise<PaginatedUserListModel> {
    return this.adminClient
      .get(`/api/v1/projects/${projectId}/users`, {
        params: query,
        paramsSerializer: (params) => qs.stringify(params, { encode: false }),
      })
      .then(selectResponseData)
      .then((response: PaginatedUserListDto) => ({
        pagination: response.pagination,
        data: response.data.map(mapUserDtoToModel),
      }));
  }

  create(id: number, model: UserModel): Promise<UserModel> {
    return this.adminClient
      .post<WithData<UserDto>>(`/api/v1/project/${id}/user`, mapUserModelToSendDto(model))
      .then(selectApiData)
      .then(mapUserDtoToModel);
  }

  update(projectId: number, model: UserModel): Promise<UserModel> {
    return this.adminClient
      .post<
        WithData<UserDto>
      >(`/api/v1/project/${projectId}/user/${model.id}`, mapUserModelToSendDto(model))
      .then(selectApiData)
      .then(mapUserDtoToModel);
  }

  delete(projectId: number, id: string): Promise<void> {
    return this.adminClient
      .delete<ApiMessage.Deleted>(`/api/v1/project/${projectId}/user/${id}`)
      .then(selectApiNoContent);
  }

  uploadExcel(file: File, id: number): Promise<void | Exception> {
    const data = new FormData();
    data.append('document', file);

    return this.adminClient.post(`/api/v1/project/${id}/user/excel`, data);
  }

  resetMfa(projectId: number, userId: string): Promise<void> {
    return this.adminClient
      .post(`/api/v1/project/${projectId}/user/${userId}/reset-mfa`)
      .then(selectApiNoContent);
  }
}
